// Persist
import {
  dbReducer,
  ReduxChange,
  ReduxFind,
  ReduxFindAll,
  ReduxInsert,
  ReduxRemove,
  ReduxUpdate,
} from '@weblite/persist'
import { IMessage, Message } from '@weblite/ts-action/message'

const COLLECTION = 'openedRoomSharedMedia'

export const openedRoomSharedMediaStorage = {
  deleteAll() {
    ReduxRemove(COLLECTION, {})
  },

  getAll(): Message[] {
    return ReduxFindAll(COLLECTION)
  },

  get(iid: number): Message {
    return ReduxFind(COLLECTION, { iid })[0]
  },

  editMessage(iid: number, patch: Pick<IMessage, 'body' | 'attachment'>) {
    ReduxUpdate(
      COLLECTION,
      { iid, 'patches.deleted': { $exists: false } },
      { $set: { ...patch, patches: { edited: true } } },
    )
  },

  deleteMessages(iids: number[]) {
    ReduxRemove(COLLECTION, { iid: { $in: iids } })
  },

  replace(messages: Message[]) {
    ReduxChange(COLLECTION, messages)
  },

  insert(messages: Message[]) {
    ReduxInsert(COLLECTION, messages)
  },
}

export const openedRoomSharedMediaReducer = dbReducer(['main', COLLECTION])
